// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__kHjJ_","overflowing":"ReadFullNote_overflowing__21Bvo"};